import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { DeleteComponentAssignmentsResponse, UserDeletionPayloadInput } from '../types';

const deleteVariableAdditionsQuery = gql`
  mutation DeleteComponentAssignments($deletions: [UserDeletionPayloadInput!]!) {
    payrollDeleteComponentAssignments(deletions: $deletions) {
      code
      success
      message
    }
  }
`;

const deleteVariableAdditions = (deletions: UserDeletionPayloadInput[]) => {
  return graphQLApi<DeleteComponentAssignmentsResponse, { deletions: UserDeletionPayloadInput[] }>({
    query: deleteVariableAdditionsQuery,
    queryVariables: { deletions },
  });
};

export default deleteVariableAdditions;
